import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import Input from 'material-ui/Input';
import {CircularProgress} from 'material-ui/Progress';
import axios from "axios";
import * as host from "../../../host/host";
import LeadRow from './LeadRow';

const columnData = [
    {_id: 'index', numeric: true, disablePadding: false, label: '#'},
    {_id: '_id', numeric: true, disablePadding: false, label: 'ID'},
    {_id: 'date', numeric: true, disablePadding: false, label: 'Дата/время'},
    {_id: 'value', numeric: true, disablePadding: false, label: 'Lead_value'},
    {_id: 'source', numeric: true, disablePadding: false, label: 'Lead_form'},
    {_id: 'url', numeric: true, disablePadding: false, label: 'Lead_url'},
    // {_id: 'pipedrive', numeric: true, disablePadding: false, label: 'PD'},
    {_id: 'user', numeric: true, disablePadding: false, label: 'USER'},
    {_id: 'Reg_date', numeric: true, disablePadding: false, label: 'Регистрация'},
    {_id: 'Client_name', numeric: true, disablePadding: false, label: 'Имя'},
    {_id: 'Client_phone', numeric: true, disablePadding: false, label: 'Телефон'},
    {_id: 'Client_email', numeric: true, disablePadding: false, label: 'Почта'},
    {_id: 'Created_companies', numeric: true, disablePadding: false, label: 'Создано компаний'},
    {_id: 'comment', numeric: true, disablePadding: false, label: 'Комментарий'},
    // {_id: 'edit', numeric: true, disablePadding: false, label: ''}
];

class EnhancedTableHead extends React.Component {
    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {order, orderBy} = this.props;
        const {classes} = this.props;
        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column._id}
                                numeric={column.numeric}
                                style={{
                                    fontSize: '14px',
                                    padding: 12,
                                    backgroundColor: 'black',
                                    color: 'white',
                                    '&:hover': {color: 'white'}
                                }}
                                className={column._id === 'index' || column._id === '_id' || column._id === 'pipedrive' || column._id === 'user' || column._id === 'edit' ? classes.tableCell : column._id === 'date' || column._id === 'Reg_date' ? classes.tableCellDate : null}
                            >
                                <TableSortLabel
                                    active={orderBy === column._id}
                                    direction={order}
                                    style={{color: 'white !important'}}
                                    classes={{active: classes.activeSortLabel, root: classes.activeSortLabel}}
                                    onClick={this.createSortHandler(column._id)}>
                                    {column.label}
                                </TableSortLabel>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


const styles = theme => ({
    tableCellDate: {
        width: 80,
        padding: '0px !important'
    },
    tableCell: {
        width: 50,
        padding: '0px !important'
    },
    activeSortLabel: {
        color: 'white !important',
    },
    root: {
        width: '100%',
        // marginTop: theme.spacing.unit * 3,
        backgroundColor: '#f5f5f5'
    },
    table: {
        minWidth: 800
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    paginationColor: '#ffffff',
    filterTitle: {
        fontSize: '15px',
        margin: '0 0 0 10px'
    },
    filterTitleMonth: {
        fontSize: '15px',
        // margin: '0 0 0 10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
            paddingRight: '10px',
        },
        [theme.breakpoints.down('md')]: {
            paddingLeft: '10px',
        }
    },
    moreFilters: {
        // fontSize: '15px',
        // margin: '0 0 0 10px',
        cursor: 'pointer'
    },
    fontSizeDefault: {
        fontSize: '15px',
        // border: '1px solid #beb7b7 ',
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '3px',
        padding: '5px',
        // marginBottom: '15px'
    },
    fontSizeTime: {
        fontSize: '12px',
        marginTop: '6px',
        marginRight: '16px',
        marginBottom: '0px'
    },
    fontSizeCells: {
        fontSize: '14px',
        padding: 12
        // paddingRight: '0px',
        // paddingLeft: '0px'
    },
    fontSizeIcons: {
        color: 'rgb(117, 117, 117)',
        cursor: 'pointer'
    },
    fontSizeHeadersList: {
        fontSize: '13px',
        lineHeight: '14px',
        fontWeight: '500'
    },
    fontSizeHeadersListCategory: {
        fontSize: '13px',
        lineHeight: '14px',
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '12px',
            paddingRight: '0px'
        },
        fontWeight: '500'
    },
    tooltipComment: {
        fontSize: '13px',
        // maxWidth: '335px'
    },
    primaryListItem: {
        fontSize: '11px !important',
    },
    fontSizeIconsFilter: {
        width: '20px',
        height: '20px'
    },
    gridList: {
        [theme.breakpoints.up('md')]: {
            padding: '0'
        }
    },
    filterRow: {
        width: '100%',
        display: 'inline-flex',
        right: '0px',
        float: 'left',
        marginTop: '10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
        }
    },
    filterRowAccount: {
        width: '100%',
        display: 'inline-flex',
        right: '0px',
        float: 'left',
        marginTop: '10px',
        [theme.breakpoints.up('lg')]: {
            float: 'right',
            marginRight: '40px'
        },
    },
    selectFilter: {
        [theme.breakpoints.down('md')]: {
            paddingRight: '20px'
        },
    },
    filterButton: {
        float: 'right',
        margin: '20px 10px 5px 10px'
    },
    modal: {
        position: 'absolute',
        border: '1px solid #e5e5e5',
        backgroundColor: '#fff',
        boxShadow: '0 5px 15px rgba(0, 0, 0, .5)',
        padding: '20px',
        [theme.breakpoints.down('xs')]: {
            top: '1%',
            left: '10%',
            height: '95%',
            width: '80%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('sm')]: {
            top: '5%',
            left: '20%',
            height: '90%',
            width: '60%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('md')]: {
            top: '10%',
            left: '10%',
            height: '570px',
            width: '80%',
            overflowY: 'none',
        },
        [theme.breakpoints.up('lg')]: {
            top: '5%',
            left: '15%',
            height: '570px',
            width: '70%',
            overflowY: 'none',
        },
    },
    modalTransfer: {
        position: 'absolute',
        border: '1px solid #e5e5e5',
        backgroundColor: '#fff',
        boxShadow: '0 5px 15px rgba(0, 0, 0, .5)',
        padding: '20px',
        [theme.breakpoints.down('xs')]: {
            top: '1%',
            left: '10%',
            height: '85%',
            width: '80%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('sm')]: {
            top: '5%',
            left: '20%',
            height: '70%',
            width: '60%',
            overflowY: 'scroll',
        },
        [theme.breakpoints.up('md')]: {
            top: '10%',
            left: '10%',
            height: '570px',
            width: '80%',
            overflowY: 'none',
        },
        [theme.breakpoints.up('lg')]: {
            top: '5%',
            left: '15%',
            height: '570px',
            width: '70%',
            overflowY: 'none',
        },
    },
    loader: {
        [theme.breakpoints.up('md')]: {
            /*left: '-220px'*/
        },
        width: '150px',
        height: '150px',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        margin: 'auto'
    },
    svgDeterminate: {
        animation: 'mui-progress-circular-rotate 1.4s linear infinite',
        transform: 'rotate(0deg)',
        // position: 'absolute',
        width: '150px',
        // marginLeft: '5%',
        // marginTop: '30px',
        // [theme.breakpoints.up('sm')]: {
        //     left: '50%',
        // },
        // [theme.breakpoints.down('sm')]: {
        //     left: '35%',
        // },
        // [theme.breakpoints.down('xs')]: {
        //     left: '25%',
        // },
        // transform: 'translate(-50%, -50%)',
    },
    svgDeterminateCell: {
        animation: 'mui-progress-circular-rotate 1.4s linear infinite',
        transform: 'rotate(0deg)',
        // position: 'absolute',
        width: '60px',
        // marginLeft: '5%',
        // marginTop: '30px',
        // [theme.breakpoints.up('sm')]: {
        //     left: '50%',
        // },
        // [theme.breakpoints.down('sm')]: {
        //     left: '35%',
        // },
        // [theme.breakpoints.down('xs')]: {
        //     left: '25%',
        // },
        // transform: 'translate(-50%, -50%)',
    },
    rootCircularProgress: {
        width: 'auto !important',
        height: 'auto !important'
    },
    mobileHeaders: {
        fontSize: '16px'
    },
    mobileListItem: {
        fontSize: '15px',
        fontWeight: '410',
        marginLeft: '30px',
        // [theme.breakpoints.down('xs')]: {
        //     marginLeft: '15px',
        // },
    },
    mobileListItemValue: {
        fontSize: '15px',
        marginRight: '10px'
    },
    mobileHeaderSum: {
        fontSize: '16px',
        fontWeight: '500'
    },
    gridContainerMobile: {
        marginBottom: '15px'
    },
    accountValue: {
        paddingTop: '5px',
        fontSize: '12px',
        marginBottom: '0px'
    },
    accountName: {
        marginBottom: '0px',
        marginTop: '17px'
    },
    fontSizeDate: {
        marginBottom: '0px',
        marginTop: '16px'
    },
    listItemMobile: {
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '10px',
            paddingRight: '10px'
        },
    },
    iconMobile: {
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    incomeIcon: {
        color: 'rgb(102, 187, 106)'
    },
    consumptionIcon: {
        color: 'rgb(239, 154, 154)'
    },
    incomeIconMobile: {
        color: 'rgb(102, 187, 106)',
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    consumptionIconMobile: {
        color: 'rgb(239, 154, 154)',
        [theme.breakpoints.down('xs')]: {
            marginRight: '0px'
        },
    },
    incomeSum: {
        color: 'rgb(102, 187, 106)',
        fontWeight: 500,
        fontSize: '14px',
        paddingRight: '0px',
        paddingLeft: '0px'
    },
    consumptionSum: {
        color: '#ff0000',
        fontSize: '14px',
        paddingRight: '0px',
        paddingLeft: '0px'
    },
    incomeSumMobile: {
        color: 'rgb(102, 187, 106)',
        fontWeight: 500,
        fontSize: '15px',
    },
    consumptionSumMobile: {
        color: '#ff0000',
        fontSize: '15px',
    },
    captionTablePagination: {
        fontSize: 14,
        paddingBottom: 0
    },
    selectTablePagination: {
        paddingRight: 25,
        paddingBottom: 0
    },
    selectIconTablePagination: {
        paddingBottom: 4
    },
    actionsTablePagination: {
        paddingBottom: 10,
        marginBottom: 10
    },
    selectItem: {
        fontSize: 16
    },
    selectItemCounterparty: {
        [theme.breakpoints.down('md')]: {
            margin: '0px 10px'
        },
        fontSize: 16
    },
    tableBody: {
        height: 200
    },
    tableHeader: {
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        tableLayout: 'fixed',
    }
});

class EnhancedTable extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getDate = this.getDate.bind(this);

        this.commentChange = this.commentChange.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.sendNewComment = this.sendNewComment.bind(this);

        this.PDChange = this.PDChange.bind(this);
        this.handleChangePD = this.handleChangePD.bind(this);
        this.sendNewPD = this.sendNewPD.bind(this);

        this.deleteLead = this.deleteLead.bind(this);

        this.updateLeads = this.updateLeads.bind(this);
        this.updateCircularProgressCell = this.updateCircularProgressCell.bind(this);

        this.handleRequestSort = this.handleRequestSort.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

        this.state = {
            order: 'desc',
            orderBy: 'index',
            selected: [],
            page: 0,
            rowsPerPage: 30,

            circularProgress: false,

            changedComment: {},
            changedPD: {},
            leads: [],
            allLeads: [],
            pd_options: [{value: true, label: '+'}, {value: false, label: '-'}],
            circularProgressCell: {_id: '', value: false},

            search_value: ''

        };
    }

    componentDidMount() {
        const _this = this;
        console.log('componentDidMount Lead');
        // console.log('lead props', _this.props);
        _this.setState({
            circularProgress: true
        });
        _this.updateLeads('');
    }

    updateLeads(currentLead) {
        console.log(currentLead);
        const _this = this;
        let leads = [];
        axios({
            url: host.url + '/admin/get_leads',
            method: 'post',
        }).then(function (response) {
            // console.log(response.data.data);
            for (let i = 0; i < response.data.data.length; i++) {
                if (response.data.data[i].visible) {
                    leads.push(response.data.data[i]);
                }
            }
            leads.sort((a, b) => (b.date < a.date ? -1 : 1));
            _this.setState({
                leads: leads,
                allLeads: leads
            }, function () {
                if (_this.state.search_value && _this.state.search_value.length > 1) {
                    _this.handleSearch(_this.state.search_value.toLowerCase(), _this.state.allLeads);
                }
                _this.setState({
                    circularProgress: false
                });
            });
        }).catch(function (error) {
            console.log('leads', error);
        });
    }

    updateCircularProgressCell(value, _id) {
        const _this = this;
        _this.setState({
            circularProgressCell: {value: value, _id: _id}
        });
    }


    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const leads =
            order === 'desc'
                ? this.state.leads.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.leads.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({leads, order, orderBy});
    };

    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({selected: this.state.leads.map(n => n._id)});
            return;
        }
        this.setState({selected: []});
    };

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    getDate(date) {
        let dateFormat = new Date(date.split('T')[0]);
        let month = (dateFormat.getMonth() + 1 < 10) ? ("0" + (dateFormat.getMonth() + 1)) : (dateFormat.getMonth() + 1);
        let day = (dateFormat.getDate() < 10) ? ("0" + dateFormat.getDate()) : dateFormat.getDate();
        let dateStringFormat = day + "." + month + '.' + dateFormat.getFullYear();
        let resultData = {
            date: dateStringFormat,
            time: (date.split('T')[1]).split('.')[0]
        };
        return resultData;
    }

    commentChange = lead => event => {
        const _this = this;
        if (_this.state.changedComment._id !== lead._id) {
            _this.setState({
                changedComment: lead
            });
            console.log('open change comment');
            event.stopPropagation();
        }
    };

    handleCommentChange(event) {
        const _this = this;
        let newComment = Object.assign({}, _this.state.changedComment);
        newComment.comment = event.target.value;
        _this.setState({
            changedComment: newComment
        });
    }

    handleSearchValueChange(event) {
        const _this = this;
        _this.setState({
            search_value: event.target.value
        });
        if (event.target.value && event.target.value.length > 1) {
            _this.handleSearch(event.target.value.toLowerCase(), _this.state.allLeads);
        }
        else if (!event.target.value) {
            _this.setState({
                leads: _this.state.allLeads
            });
        }
    }

    handleSearch(search_parament, array) {
        const _this = this;
        let newLeadsArray = [];
        let flagIn;
        for (let i = 0; i < array.length; i++) {
            flagIn = false;
            for (let key in array[i]) {
                if (Array.isArray(array[i][key])) {
                    for (let j = 0; j < array[i][key].length; j++) {
                        if (array[i][key][j].name.toLowerCase().indexOf(search_parament) !== -1) {
                            newLeadsArray.push(array[i]);
                            flagIn = true;
                            break;
                        }
                    }
                }
                else if (array[i][key] && array[i][key].toString().toLowerCase().indexOf(search_parament) !== -1) {
                    newLeadsArray.push(array[i]);
                    break;
                }
                if (flagIn) {
                    break;
                }
            }
        }

        _this.setState({
            leads: newLeadsArray
        });
    }

    sendNewComment = (event, lead) => {
        const _this = this;
        if (_this.state.changedComment.comment !== lead.comment) {
            console.log('send', _this.state.changedComment);
        }
        _this.setState({
            changedComment: {_id: ''}
        });
    };

    PDChange = lead => event => {
        const _this = this;
        let newChangedPD = Object.assign({}, lead);
        newChangedPD.pipedrive = lead.pipedrive ? {
                label: '+',
                value: true
            } :
            {
                label: '-',
                value: false
            };
        if (_this.state.changedPD._id !== lead._id) {
            _this.setState({
                changedPD: newChangedPD
            });
            console.log('open change PD', newChangedPD);
            event.stopPropagation();
        }
    };

    handleChangePD(event) {
        const _this = this;
        let newPD = Object.assign({}, _this.state.changedPD);
        newPD.pipedrive = Object.assign({}, event);
        _this.setState({
            changedPD: newPD
        });
        console.log('change PD', newPD);
    }

    sendNewPD = (event, lead) => {
        const _this = this;
        if (_this.state.changedPD.pipedrive.value !== lead.pipedrive) {
            console.log('send', _this.state.changedPD);
            _this.setState({
                circularProgress: true
            });
            axios({
                url: host.url + '/admin/update_lead_pipedrive',
                method: 'post',
                data: {
                    lead_id: _this.state.changedPD._id,
                    boolean: _this.state.changedPD.pipedrive.value
                }
            }).then(function () {
                _this.updateLeads();
            }).catch(function (error) {
                console.log('change pipedrive', error);
            });
        }
        _this.setState({
            changedPD: {value: '', label: ''}
        });
    };

    deleteLead = lead => () => {
        console.log('delete lead', lead);
    };


    render() {
        const _this = this;
        const {classes} = this.props;
        const {order, orderBy, selected, rowsPerPage, page} = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, _this.state.leads.length - page * rowsPerPage);
        return (
            <div>
                {_this.state.circularProgress ?
                    <Grid container spacing={0} style={{textAlign: 'center', display: 'inherit'}}>
                        <CircularProgress
                            className={classes.progress}
                            classes={{svgDeterminate: classes.svgDeterminate, root: classes.rootCircularProgress}}
                            mode="determinate"
                            value={75}/>
                    </Grid> :
                    <div>
                        <Paper className={classes.root}>
                            <div>
                                <Input
                                    className={classes.fontSizeDefault}
                                    type='text'
                                    // value={_this.state.search_value}
                                    onChange={_this.handleSearchValueChange}
                                    placeholder='Поиск...'
                                    fullWidth={true}
                                    disableUnderline={true}
                                />
                            </div>
                            <div className={classes.tableWrapper}>
                                <div>
                                    <Table
                                        className={classes.tableHeader}
                                    >
                                        <EnhancedTableHead
                                            numSelected={selected.length}
                                            order={order}
                                            orderBy={orderBy}
                                            onSelectAllClick={this.handleSelectAllClick}
                                            onRequestSort={this.handleRequestSort}
                                            rowCount={_this.state.leads.length}
                                            classes={classes}
                                        />
                                    </Table>
                                </div>
                                <div
                                    style={{
                                        height: 'calc(100vh + 26px)',
                                        overflowY: 'scroll'
                                    }}
                                >
                                    <Table
                                        className={classes.tableHeader}
                                    >
                                        {/*<EnhancedTableHead*/}
                                            {/*numSelected={selected.length}*/}
                                            {/*order={order}*/}
                                            {/*orderBy={orderBy}*/}
                                            {/*onSelectAllClick={this.handleSelectAllClick}*/}
                                            {/*onRequestSort={this.handleRequestSort}*/}
                                            {/*rowCount={_this.state.leads.length}*/}
                                            {/*classes={classes}*/}
                                        {/*/>*/}
                                        <TableBody
                                            // classes={{root: classes.tableBody}}
                                        >
                                            {_this.state.leads.length ?
                                                _this.state.leads.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(lead => {
                                                    return (
                                                        _this.state.circularProgressCell._id === lead._id && _this.state.circularProgressCell.value ?
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={lead._id}
                                                            >
                                                                <TableCell colSpan={14} style={{textAlign: 'center'}}>
                                                                    <CircularProgress
                                                                        className={classes.progress}
                                                                        classes={{
                                                                            svgDeterminate: classes.svgDeterminateCell,
                                                                            root: classes.rootCircularProgress
                                                                        }}
                                                                        mode="determinate"
                                                                        value={75}/>
                                                                </TableCell>
                                                            </TableRow> :
                                                            <LeadRow key={lead._id}
                                                                     lead={lead}
                                                                     updateLeads={_this.updateLeads}
                                                            />
                                                    );
                                                })
                                                :
                                                <TableRow>
                                                    <TableCell colSpan={10}
                                                               style={{textAlign: 'center', fontSize: '14px'}}>
                                                        У вас пока нету лидов.
                                                    </TableCell>
                                                </TableRow>
                                            }
                                            {emptyRows > 0 && (
                                                <TableRow style={{height: 49 * emptyRows}}>
                                                    <TableCell colSpan={14}/>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        {/*<TableFooter style={{fontSize: '16px'}}>*/}
                                        {/*<TableRow style={{fontSize: '16px'}}>*/}
                                        {/*<TablePagination*/}
                                        {/*style={{fontSize: '16px'}}*/}
                                        {/*className={classes.paginationColor}*/}
                                        {/*classes={{*/}
                                        {/*caption: classes.captionTablePagination,*/}
                                        {/*actions: classes.actionsTablePagination,*/}
                                        {/*select: classes.selectTablePagination,*/}
                                        {/*selectIcon: classes.selectIconTablePagination*/}
                                        {/*}}*/}
                                        {/*count={_this.state.leads.length}*/}
                                        {/*rowsPerPage={rowsPerPage}*/}
                                        {/*page={page}*/}
                                        {/*onChangePage={this.handleChangePage}*/}
                                        {/*onChangeRowsPerPage={this.handleChangeRowsPerPage}*/}
                                        {/*rowsPerPageOptions={[30, 50, 100]}*/}
                                        {/*labelRowsPerPage="Кол-во записей"*/}
                                        {/*labelDisplayedRows={({from, to, count}) => `${from}-${to} с ${count}`}*/}
                                        {/*/>*/}
                                        {/*</TableRow>*/}
                                        {/*</TableFooter>*/}
                                    </Table>
                                </div>
                                <Table>
                                    <TableFooter style={{fontSize: '16px'}}>
                                        <TableRow style={{fontSize: '16px'}}>
                                            <TablePagination
                                                style={{fontSize: '16px'}}
                                                className={classes.paginationColor}
                                                classes={{
                                                    caption: classes.captionTablePagination,
                                                    actions: classes.actionsTablePagination,
                                                    select: classes.selectTablePagination,
                                                    selectIcon: classes.selectIconTablePagination
                                                }}
                                                count={_this.state.leads.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                rowsPerPageOptions={[30, 50, 100]}
                                                labelRowsPerPage="Кол-во записей"
                                                labelDisplayedRows={({from, to, count}) => `${from}-${to} с ${count}`}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </div>
                        </Paper>
                    </div>
                }
            </div>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EnhancedTable);



// WEBPACK FOOTER //
// ./src/components/tabs/leads/Leads.js